// @greenlight-spec: 28-it-dashboard-ui.md

/**
 * Triggers a client-side file download of `content` as `filename`. Used by the
 * feedback export (docs/28 §/feedback) to hand a concatenated Markdown file to
 * the platform team without a server round-trip. Creates a transient object URL,
 * clicks a detached anchor, then revokes the URL.
 */
export function downloadTextFile(
  filename: string,
  content: string,
  mimeType = 'text/markdown',
): void {
  const blob = new Blob([content], { type: `${mimeType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
